import { StyleSheet } from 'react-native';

const styles = StyleSheet.create({
    overFlow: { overflow: 'hidden' },
    container: {
        width: '100%',
        height: '100%',
        position: 'absolute',
        backgroundColor: '#1D1D1D',
        zIndex: -1,
    },
});

export default styles;
